import React from "react";
import { useSelector } from "react-redux";
import PercentageDisplay from "../../../../components/percentageDisplay/percentageDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const ProfilesToFirstVisit = () => {
  const { profilesToFirstVisit, profilesToFirstVisitChange } = useSelector(
    (state) => state.marketing.profileRetention
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);
  return (
    <>
      <PercentageDisplay value={Math.round(profilesToFirstVisit * 100)} disableAnimation={isUserQa} />
      <PercentChanged
        changeValue={profilesToFirstVisitChange}
        toolTip="Percent change from previous month"
        showBorder
      />
    </>
  );
};

export default ProfilesToFirstVisit;
